module.exports = __webpack_public_path__ + "img/0Q3A2889_L_WoodMatted_MockedUp.79b2e6e6.jpg";